export interface AuditDetailModel {
  eventValidatedBy?: string;
  eventValidatedAt?: string;
  eventSentforValidationBy?: string;
}
